export default __webpack_public_path__ + "static/media/47UT612.18a41f87.png";